'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toLowerCase2 = require('./_internal/_toLowerCase');

var _toLowerCase3 = _interopRequireDefault(_toLowerCase2);

var _alias = require('./alias');

var _alias2 = _interopRequireDefault(_alias);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Alias for the map tag. The Map element defines a map of Areas that allows
 * regions of an image to be clickable.
 *
 * @module Map
 * @func
 * @since 1.0.0
 * @param {Object} props
 */

var STR_NAME = 'Map';
var STR_TAG = (0, _toLowerCase3.default)(STR_NAME);

var Map = (0, _alias2.default)(STR_TAG, STR_NAME);

exports.default = Map;